import React, { Fragment } from 'react';
import VariantSnackbar from '../components/share/VariantSnackbar';

const SnackbarContext = React.createContext({
  open: false,
  message: '',
  duration: 3000,
  labelAction: '',
  handleAction: null,
  variant: 'success',
  vertical: 'top',
  horizontal: 'center',
});

class SnackbarProvider extends React.Component {
  state = {
    open: false,
    message: '',
    duration: 3000,
    labelAction: '',
    handleAction: null,
    variant: 'success',
    vertical: 'top',
    horizontal: 'center',
  }

  showSnackbar = (message, variant = 'success', duration = 3000,
    labelAction = '', handleAction = null,
    vertical = 'top', horizontal = 'center') => {
    this.setState({
      open: true,
      message: message,
      variant: variant,
      duration: duration,
      labelAction: labelAction,
      handleAction: handleAction,
      vertical: vertical,
      horizontal: horizontal,
    });
  }

  hideSnackbar = () => {
    this.setState({ open: false });
  }

  render () {
    return (
      <SnackbarContext.Provider
        value={{
          open: this.state.open,
          message: this.state.message,
          variant: this.state.variant,
          duration: this.state.duration,
          labelAction: this.state.labelAction,
          handleAction: this.state.handleAction,
          vertical: this.state.vertical,
          horizontal: this.state.horizontal,
          showSnackbar: this.showSnackbar,
          hideSnackbar: this.hideSnackbar,
        }}
      >
        <SnackbarConsumer>
          {({ open, message, variant, duration, labelAction, handleAction, vertical, horizontal, hideSnackbar }) => {
            return (
              <Fragment>
                {open && <VariantSnackbar
                  open={open} message={message} variant={variant} duration={duration}
                  labelAction={labelAction} handleAction={handleAction}
                  vertical={vertical} horizontal={horizontal} handleClose={hideSnackbar} />}
              </Fragment>
            );
          }
          }
        </SnackbarConsumer>
        {this.props.children}
      </SnackbarContext.Provider>
    );
  }
}

const SnackbarConsumer = SnackbarContext.Consumer;

function withSnackbar (Component) {
  return function ComponentwithSnackbar (props) {
    return (
      <SnackbarConsumer>
        {({ showSnackbar, hideSnackbar }) =>
          <Component {...props} showSnackbar={showSnackbar} hideSnackbar={hideSnackbar} />
        }
      </SnackbarConsumer>
    );
  };
}
export { SnackbarProvider, SnackbarConsumer, withSnackbar };
